<template>
  <deviceList
    v-if="deviceTypeCode"
    :deviceTypeCode="deviceTypeCode"
    :showMonitorRangeColumn="false"
    :showOperationColumn="false"
    :linkParam="linkParam"
    :locationSetName="locationSetName">
    </deviceList>
</template>

<script>
import { DataCategoryApi } from '@wiz-api/data-category-management'
import deviceList from '../../../components/device-list'

const dataCategoryApi = new DataCategoryApi()
const deviceTypeNameKeyWord = '道闸'
const componentName = 'barrierGateList'

export default {
  name: componentName,
  components: {
    deviceList,
  },
  data() {
    return {
      deviceTypeCode: '',
      deviceTypeList: [],
      linkParam: 'IOTDeviceBarrierGate',
      locationSetName: '道闸点位设置',
    }
  },
  methods: {
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (!err) {
        let deviceTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateDeviceType') { // 类型归属
            deviceTypeList = item.dataItems
          }
        })
        if (Array.isArray(deviceTypeList)) {
          for (let i = 0; i < deviceTypeList.length; i++) {
            const ele = deviceTypeList[i]
            if (ele.displayName.includes(deviceTypeNameKeyWord)) {
              this.deviceTypeCode = ele.code
            }
          }
        }
      }
    },
  },
  async created() {
    this.getCategoryByCodes()
  },
}
</script>

<style lang="scss" scoped></style>
